import { render, staticRenderFns } from "./BookingChangeLog.vue?vue&type=template&id=2f34cff4&scoped=true&"
import script from "./BookingChangeLog.vue?vue&type=script&lang=js&"
export * from "./BookingChangeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34cff4",
  null
  
)

export default component.exports